import * as react from "react";
import { Lazy, int32ToString, defaultOf, equals } from "../Bfs.Web.Kundenportal/fable_modules/fable-library-js.4.19.0/Util.js";
import { GlobalMessageBoxButtonType, GlobalMsg, Msg } from "./Types.fs.js";
import { append, empty, singleton, collect, delay, toList } from "../Bfs.Web.Kundenportal/fable_modules/fable-library-js.4.19.0/Seq.js";
import { menuItemDefinition, menuItemDefinition__isVisible_7F866359 } from "./MenuDef.fs.js";
import { DOMAttr, HTMLAttr } from "../Bfs.Web.Kundenportal/fable_modules/Fable.React.9.4.0/Fable.React.Props.fs.js";
import { keyValueList } from "../Bfs.Web.Kundenportal/fable_modules/fable-library-js.4.19.0/MapUtil.js";
import { Tab_Option, tab as tab_3, Option, tabs } from "../Bfs.Web.Kundenportal/fable_modules/Fulma.3.0.0/Components/Tabs.fs.js";
import { tryFind, ofArray, exists, isEmpty, singleton as singleton_1 } from "../Bfs.Web.Kundenportal/fable_modules/fable-library-js.4.19.0/List.js";
import { FunctionComponentPreparedRenderFunctionCache_GetOrAdd_3560CE5E } from "../Bfs.Web.Kundenportal/fable_modules/Fable.React.9.4.0/./Fable.React.FunctionComponent.fs.js";
import { map, defaultArg, value as value_1 } from "../Bfs.Web.Kundenportal/fable_modules/fable-library-js.4.19.0/Option.js";
import { nothing, icon as icon_1 } from "./ViewParts.fs.js";
import { CollapsableElement } from "./Collapsable.fs.js";
import { Record } from "../Bfs.Web.Kundenportal/fable_modules/fable-library-js.4.19.0/Types.js";
import { record_type, lambda_type, list_type, class_type } from "../Bfs.Web.Kundenportal/fable_modules/fable-library-js.4.19.0/Reflection.js";

export function contentWrapper(body) {
    const children_2 = [react.createElement("div", {
        className: "content-body",
    }, ...body)];
    return react.createElement("div", {
        className: "content-wrapper",
    }, ...children_2);
}

function Menu_menuCaption(tab) {
    const matchValue = tab.Icon;
    if (matchValue == null) {
        return tab.Title;
    }
    else {
        return matchValue;
    }
}

function Menu_simpleMainMenuTab(dispatch, tab) {
    let children;
    const children_2 = [(children = [Menu_menuCaption(tab)], react.createElement("div", {}, ...children))];
    return react.createElement("a", {
        className: "main-menu-item",
        onClick: (_arg) => {
            if (!equals(tab.Page, defaultOf())) {
                dispatch(new Msg(3, [tab.Page]));
            }
        },
    }, ...children_2);
}

function Menu_submenuTab(model, roles, dispatch, tab) {
    let children, children_6, children_4;
    const children_8 = [(children = [Menu_menuCaption(tab)], react.createElement("div", {
        className: "dropdown-trigger",
    }, ...children)), (children_6 = [(children_4 = toList(delay(() => collect((sub) => {
        let props_2, children_2;
        return menuItemDefinition__isVisible_7F866359(sub, roles) ? singleton((props_2 = [new HTMLAttr(65, ["dropdown-item submenu-item " + (sub.IsActive(model) ? "is-active" : "")]), new DOMAttr(40, [(_arg) => {
            if (!equals(sub.Page, defaultOf())) {
                dispatch(new Msg(3, [sub.Page]));
            }
        }])], (children_2 = [Menu_menuCaption(sub)], react.createElement("a", keyValueList(props_2, 1), ...children_2)))) : empty();
    }, tab.Subitems))), react.createElement("div", {
        className: "dropdown-content",
    }, ...children_4))], react.createElement("div", {
        className: "dropdown-menu",
    }, ...children_6))];
    return react.createElement("a", {
        className: "main-menu-item dropdown is-hoverable",
    }, ...children_8);
}

export function Menu_mainMenuDesktop(dispatch, model, menu, user) {
    const roles = user.Roles;
    return tabs(singleton_1(new Option(7, ["account-tabs has-controls is-hidden-touch main-menu test"])), toList(delay(() => collect((tab) => (menuItemDefinition__isVisible_7F866359(tab, roles) ? singleton(tab_3(singleton_1(new Tab_Option(0, [tab.IsActive(model)])), toList(delay(() => singleton(isEmpty(tab.Subitems) ? Menu_simpleMainMenuTab(dispatch, tab) : Menu_submenuTab(model, roles, dispatch, tab)))))) : empty()), menu))));
}

function Menu_dropdownMenuEntry(dispatch, model, item) {
    const active = item.IsActive(model) ? "is-active" : "";
    const children_2 = [react.createElement("a", {
        className: "dropdown-item",
        onClick: (_arg) => {
            const matchValue = item.OnClick;
            if (matchValue == null) {
                dispatch(new Msg(3, [item.Page]));
            }
            else {
                matchValue();
            }
        },
    }, item.Title)];
    return react.createElement("li", {
        className: active,
    }, ...children_2);
}

export function dropdownMenuGroup$004080() {
    return FunctionComponentPreparedRenderFunctionCache_GetOrAdd_3560CE5E((((value_1("C:\\BuildAgent\\work\\c238671ccc1e7da2\\BfsKundenportal\\src\\Bfs.Web.Portale\\Template.fs") + "#L") + int32ToString(value_1(81))) + ";") + "System.Tuple`4[Microsoft.FSharp.Core.FSharpFunc`2[Types.Msg,Microsoft.FSharp.Core.Unit],Types.Model,Types.UserSession,MenuDef.menuItemDefinition]", value_1("dropdownMenuGroup"), (tupledArg) => {
        let children;
        const item = tupledArg[3];
        const isOpen = react.useState(false);
        const isOpenClass = react.useState("");
        react.useEffect(() => {
            isOpenClass[1]((isOpen[0]) ? "expanded" : "");
        }, [isOpen[0]]);
        const props_2 = [new HTMLAttr(65, [isOpenClass[0]])];
        const children_2 = [(children = [icon_1("fas fa-chevron-right"), item.Title], react.createElement("label", {
            onClick: (_arg_1) => {
                isOpen[1](!(isOpen[0]));
            },
        }, ...children)), CollapsableElement([dropdownMenuEntries$0040105$002D1.Value([tupledArg[0], tupledArg[1], tupledArg[2], item.Subitems]), isOpen[0]])];
        return react.createElement("li", keyValueList(props_2, 1), ...children_2);
    }, undefined, undefined, "Of");
}

export const dropdownMenuGroup$004080$002D1 = new Lazy(dropdownMenuGroup$004080);

export function dropdownMenuEntries$0040105() {
    return FunctionComponentPreparedRenderFunctionCache_GetOrAdd_3560CE5E((((value_1("C:\\BuildAgent\\work\\c238671ccc1e7da2\\BfsKundenportal\\src\\Bfs.Web.Portale\\Template.fs") + "#L") + int32ToString(value_1(106))) + ";") + "System.Tuple`4[Microsoft.FSharp.Core.FSharpFunc`2[Types.Msg,Microsoft.FSharp.Core.Unit],Types.Model,Types.UserSession,Microsoft.FSharp.Collections.FSharpList`1[MenuDef.menuItemDefinition]]", value_1("dropdownMenuEntries"), (tupledArg) => {
        const dispatch = tupledArg[0];
        const model = tupledArg[1];
        const user = tupledArg[2];
        const children = toList(delay(() => collect((item) => (menuItemDefinition__isVisible_7F866359(item, user.Roles) ? (!equals(item.Page, defaultOf()) ? singleton(Menu_dropdownMenuEntry(dispatch, model, item)) : singleton(dropdownMenuGroup$004080$002D1.Value([dispatch, model, user, item]))) : empty()), tupledArg[3])));
        return react.createElement("ul", {}, ...children);
    }, undefined, undefined, "Of");
}

export const dropdownMenuEntries$0040105$002D1 = new Lazy(dropdownMenuEntries$0040105);

const Menu_dropdownMenuGroup = dropdownMenuGroup$004080$002D1.Value;

const Menu_dropdownMenuEntries = dropdownMenuEntries$0040105$002D1.Value;

export function Menu_subMenuDesktop(dispatch, model, menu, userMenu, usericonClass, notificationTrigger, user) {
    const children_16 = toList(delay(() => append((notificationTrigger != null) ? singleton(value_1(notificationTrigger)) : empty(), delay(() => append(collect((tab) => {
        let children;
        if (menuItemDefinition__isVisible_7F866359(tab, user.Roles)) {
            const active = tab.IsActive(model) ? "is-active" : "";
            return singleton((children = [Menu_menuCaption(tab)], react.createElement("a", {
                className: active,
                onClick: (_arg) => {
                    dispatch(new Msg(3, [tab.Page]));
                },
            }, ...children)));
        }
        else {
            return empty();
        }
    }, menu), delay(() => {
        let children_14, children_8, children_12, children_10;
        return singleton((children_14 = [(children_8 = [react.createElement("i", {
            className: usericonClass,
        }), react.createElement("p", {}, user.Name), react.createElement("i", {
            className: "fas fa-angle-down",
        })], react.createElement("div", {
            className: "dropdown-trigger",
        }, ...children_8)), (children_12 = [(children_10 = [Menu_dropdownMenuEntries([dispatch, model, value_1(model.User), userMenu])], react.createElement("div", {
            className: "dropdown-content",
        }, ...children_10))], react.createElement("div", {
            className: "dropdown-menu",
        }, ...children_12))], react.createElement("div", {
            className: "dropdown is-hoverable is-right",
        }, ...children_14)));
    }))))));
    return react.createElement("div", {
        className: "subMenu is-hidden-touch",
    }, ...children_16);
}

export function Menu_mobileMenuTrigger(dispatch, isOpen, notificationTrigger) {
    const menuopen = isOpen ? "is-active" : "";
    const children_4 = toList(delay(() => append((notificationTrigger != null) ? singleton(value_1(notificationTrigger)) : empty(), delay(() => {
        let props_2, children_2;
        return singleton((props_2 = [new HTMLAttr(65, ["dropdown dropdown-trigger " + menuopen]), new DOMAttr(40, [(_arg) => {
            dispatch(new Msg(5, []));
        }])], (children_2 = [react.createElement("i", {
            className: "fas fa-bars",
        })], react.createElement("a", keyValueList(props_2, 1), ...children_2))));
    }))));
    return react.createElement("span", {
        className: "is-hidden-desktop is-right is-flex is-flex-direction-row",
    }, ...children_4);
}

export function Menu_mobileMenu(dispatch, model, menu, userMenu, notificationDropdown) {
    let page, sub_2, children_2, children, children_4;
    const username = defaultArg(map((_arg) => _arg.Name, model.User), "");
    const matchValue = model.User;
    if (matchValue == null) {
        return nothing;
    }
    else {
        const user = matchValue;
        const userMenuCategory = singleton_1((page = defaultOf(), (sub_2 = toList(delay(() => userMenu)), new menuItemDefinition(username, undefined, "", page, sub_2, (m) => ((((typeof m.PageModel === "string") ? true : (typeof m.PageModel === "string")) ? true : (typeof m.PageModel === "string")) ? true : exists((subMenu) => subMenu.IsActive(m), sub_2)), undefined))));
        const children_6 = [CollapsableElement([(children_2 = [(children = [Menu_dropdownMenuEntries([dispatch, model, value_1(model.User), menu]), react.createElement("hr", {
            className: "dropdown-divider",
        }), Menu_dropdownMenuEntries([dispatch, model, value_1(model.User), userMenuCategory])], react.createElement("div", {
            className: "navbar-start",
        }, ...children))], react.createElement("div", {
            className: "navbar-menu is-hidden-desktop is-active mobile-menu",
        }, ...children_2)), model.IsBurgerMenuOpen]), CollapsableElement([(children_4 = toList(delay(() => ((notificationDropdown != null) ? singleton(value_1(notificationDropdown)) : empty()))), react.createElement("div", {
            className: "navbar-menu is-hidden-desktop is-active mobile-menu",
        }, ...children_4)), model.IsNotificationMenuOpen])];
        return react.createElement("div", {
            className: "mobile-menu-wrapper",
        }, ...children_6);
    }
}

export class Menu_NotificationMenu extends Record {
    constructor(ContextProvider, DesktopTriggerAndDropdown, MobileTrigger, MobileDropdown) {
        super();
        this.ContextProvider = ContextProvider;
        this.DesktopTriggerAndDropdown = DesktopTriggerAndDropdown;
        this.MobileTrigger = MobileTrigger;
        this.MobileDropdown = MobileDropdown;
    }
}

export function Menu_NotificationMenu_$reflection() {
    return record_type("Template.Menu.NotificationMenu", [], Menu_NotificationMenu, () => [["ContextProvider", lambda_type(list_type(class_type("Fable.React.ReactElement")), class_type("Fable.React.ReactElement"))], ["DesktopTriggerAndDropdown", class_type("Fable.React.ReactElement")], ["MobileTrigger", class_type("Fable.React.ReactElement")], ["MobileDropdown", class_type("Fable.React.ReactElement")]]);
}

export function Footer_bfsFooterContent(dispatch, impressumPage, datenschutzPage) {
    let children_4, children_10;
    return [(children_4 = [react.createElement("span", {}, "© "), react.createElement("a", {
        href: "https://www.bfs-abrechnung.de/",
    }, "BFS Abrechnungs GmbH")], react.createElement("div", {}, ...children_4)), (children_10 = [react.createElement("a", {
        className: "space-right",
        onClick: (_arg) => {
            dispatch(new Msg(3, [impressumPage]));
        },
    }, "Impressum"), react.createElement("a", {
        onClick: (_arg_1) => {
            dispatch(new Msg(3, [datenschutzPage]));
        },
    }, "Datenschutz")], react.createElement("div", {}, ...children_10))];
}

export function Footer_bfsFooter(dispatch, impressumPage, datenschutzPage) {
    const children = [contentWrapper(singleton_1(Footer_bfsFooterContent(dispatch, impressumPage, datenschutzPage)))];
    return react.createElement("footer", {}, ...children);
}

export function Header_render(dispatch, model, bigCoverPicture, mainMenu, subMenu, mobileMenu, userMenu, usericonClass, notifications) {
    const loginpage = (model.User == null) ? " loginpage " : "";
    const notificationContext = defaultArg(map((_arg) => _arg.ContextProvider, notifications), (children) => react.createElement(react.Fragment, {}, ...children));
    return Array.from(delay(() => {
        let children_6;
        return append(singleton((children_6 = [contentWrapper(singleton_1(notificationContext(toList(delay(() => {
            let props_4, children_4;
            return append(singleton((props_4 = [new HTMLAttr(65, ["logoblock" + loginpage])], (children_4 = toList(delay(() => append(singleton(react.createElement("a", {
                onClick: (_arg_1) => {
                    dispatch(new Msg(4, []));
                },
                className: "logo",
            })), delay(() => ((model.User != null) ? singleton(Menu_mobileMenuTrigger(dispatch, model.IsBurgerMenuOpen, map((_arg_2) => _arg_2.MobileTrigger, notifications))) : empty()))))), react.createElement("div", keyValueList(props_4, 1), ...children_4)))), delay(() => ((model.User != null) ? append(singleton(Menu_mainMenuDesktop(dispatch, model, mainMenu, value_1(model.User))), delay(() => append(singleton(Menu_subMenuDesktop(dispatch, model, subMenu, userMenu, usericonClass, map((_arg_3) => _arg_3.DesktopTriggerAndDropdown, notifications), value_1(model.User))), delay(() => singleton(Menu_mobileMenu(dispatch, model, mobileMenu, userMenu, map((_arg_4) => _arg_4.MobileDropdown, notifications))))))) : empty())));
        })))))], react.createElement("header", {}, ...children_6))), delay(() => {
            let children_8;
            return (bigCoverPicture != null) ? singleton((children_8 = [contentWrapper(singleton_1(value_1(bigCoverPicture)))], react.createElement("div", {
                className: "logo-container-big-cover",
            }, ...children_8))) : empty();
        }));
    }));
}

function Main_headerText(header) {
    const children_6 = toList(delay(() => {
        let children_4;
        return (header.tag === 1) ? singleton(react.createElement("h2", {}, header.fields[0])) : ((header.tag === 2) ? singleton((children_4 = [header.fields[0], react.createElement("p", {
            className: "subheader",
        }, header.fields[1])], react.createElement("h2", {}, ...children_4))) : singleton(nothing));
    }));
    return react.createElement("div", {
        className: "category-header",
    }, ...children_6);
}

export function Main_render(pageHeader, body) {
    const children = [contentWrapper(ofArray([Main_headerText(pageHeader), body]))];
    return react.createElement("main", {}, ...children);
}

export function buttonOnClick(button, dispatch) {
    return new DOMAttr(40, [(_arg) => {
        if (button.Message != null) {
            dispatch(new Msg(1, [value_1(button.Message)]));
        }
        if (button.ClosesDialog) {
            dispatch(new Msg(0, [new GlobalMsg(4, [])]));
        }
    }]);
}

export function getButton(buttonType, buttonClass, buttonList, dispatch) {
    const butt = tryFind((b) => equals(b.Type, buttonType), buttonList);
    if (butt == null) {
        return "";
    }
    else {
        const b_1 = butt;
        const props = [buttonClass, buttonOnClick(b_1, dispatch)];
        return react.createElement("button", keyValueList(props, 1), b_1.Caption);
    }
}

export function messageBox(dispatch, data) {
    let children_14, props_14, children_12, children_6, children_10;
    let className;
    const matchValue = data.Type;
    switch (matchValue.tag) {
        case 2: {
            className = "is-bfscolored";
            break;
        }
        case 1:
        case 0: {
            className = "is-bfscolored";
            break;
        }
        default:
            className = "is-danger";
    }
    const buttonClass = new HTMLAttr(65, ["button " + className]);
    const children_16 = [react.createElement("div", {
        className: "modal-background",
    }), (children_14 = [(props_14 = [new HTMLAttr(65, ["message " + className])], (children_12 = [(children_6 = [react.createElement("p", {}, data.Title), react.createElement("button", {
        className: "delete",
        onClick: (_arg) => {
            dispatch(new Msg(0, [new GlobalMsg(4, [])]));
        },
    })], react.createElement("div", {
        className: "message-header",
    }, ...children_6)), (children_10 = toList(delay(() => append(singleton(data.BodyElement), delay(() => append(singleton(react.createElement("br", {})), delay(() => {
        let children_8;
        return singleton((children_8 = [getButton(new GlobalMessageBoxButtonType(2, []), buttonClass, data.Buttons, dispatch), getButton(new GlobalMessageBoxButtonType(0, []), buttonClass, data.Buttons, dispatch), getButton(new GlobalMessageBoxButtonType(1, []), buttonClass, data.Buttons, dispatch), getButton(new GlobalMessageBoxButtonType(3, []), buttonClass, data.Buttons, dispatch)], react.createElement("div", {
            className: "button-container",
        }, ...children_8)));
    })))))), react.createElement("div", {
        className: "message-body",
    }, ...children_10))], react.createElement("div", keyValueList(props_14, 1), ...children_12)))], react.createElement("div", {
        className: "modal-content",
    }, ...children_14))];
    return react.createElement("div", {
        className: "modal is-active",
    }, ...children_16);
}

export function messageBoxComponent(boxType, wider, title, body, onClose, buttons) {
    let props_16, children_14, props_14, children_12, children_6, children_10;
    const className = (boxType.tag === 2) ? "is-bfscolored" : ((boxType.tag === 1) ? "is-bfscolored" : ((boxType.tag === 0) ? "is-bfscolored" : "is-danger"));
    const children_16 = [react.createElement("div", {
        className: "modal-background",
    }), (props_16 = [new HTMLAttr(65, ["modal-content" + (wider ? " modal-wide" : "")])], (children_14 = [(props_14 = [new HTMLAttr(65, ["message " + className])], (children_12 = [(children_6 = [react.createElement("p", {}, title), react.createElement("button", {
        className: "delete",
        onClick: (_arg) => {
            onClose();
        },
    })], react.createElement("div", {
        className: "message-header",
    }, ...children_6)), (children_10 = toList(delay(() => append(singleton(body), delay(() => append(singleton(react.createElement("br", {})), delay(() => singleton(react.createElement("div", {
        className: "button-container",
    }, ...buttons)))))))), react.createElement("div", {
        className: "message-body",
    }, ...children_10))], react.createElement("div", keyValueList(props_14, 1), ...children_12)))], react.createElement("div", keyValueList(props_16, 1), ...children_14)))];
    return react.createElement("div", {
        className: "modal is-active",
    }, ...children_16);
}

export function videoOverlay(dispatch, video) {
    let children_4;
    const children_6 = [react.createElement("div", {
        className: "modal-background",
        onClick: (_arg) => {
            dispatch(new Msg(0, [new GlobalMsg(6, [])]));
        },
    }), (children_4 = [react.createElement("iframe", {
        src: `https://player.vimeo.com/video/${video.fields[0]}?dnt=1&autoplay=1`,
        frameBorder: "0",
        allow: "autoplay; fullscreen",
        allowFullScreen: true,
        autoPlay: true,
    })], react.createElement("div", {
        className: "modal-content",
    }, ...children_4))];
    return react.createElement("div", {
        className: "modal is-active video-overlay",
    }, ...children_6);
}

export function main(dispatch, model, pageHeader, bigCoverPicture, usericonClass, topMenu, userMenu, mainMenu, mobileMenu, notifications, impressumPage, datenschutzPage, backgroundClass, body) {
    const children = toList(delay(() => append(singleton(Header_render(dispatch, model, bigCoverPicture, mainMenu, topMenu, mobileMenu, userMenu, usericonClass, notifications)), delay(() => append(singleton(Main_render(pageHeader, body)), delay(() => append(singleton(Footer_bfsFooter(dispatch, impressumPage, datenschutzPage)), delay(() => append((model.VideoOverlayVimeoId != null) ? singleton(videoOverlay(dispatch, value_1(model.VideoOverlayVimeoId))) : empty(), delay(() => ((model.MessageBox != null) ? singleton(messageBox(dispatch, value_1(model.MessageBox))) : empty())))))))))));
    return react.createElement("div", {
        className: backgroundClass,
    }, ...children);
}

//# sourceMappingURL=Template.fs.js.map
